import { get, post, put } from "../Config";


// GET
export function WordBookAllView({ data }) {
  return post({ url: `/api/koala/v1/wordbook-all`, data });
}

export function WordBookQuizView({ data }) {
  return post({ url: `/api/koala/v1/wordbook-quiz`, data });
}

export function WordBookAnswerView({ wordBookQuizId = 0 }) {
  return get({ url: `/api/koala/v1/wordbook-quiz-detail?wordBookQuizId=${wordBookQuizId}`});
}

export function WordBookAnswer({ data }) {
  return post({ url: `/api/koala/v1/wordbook-answer` , data});
}
